export const LOGIN_DO_LOGIN_BEGIN = 'LOGIN_DO_LOGIN_BEGIN';
export const LOGIN_DO_LOGIN_SUCCESS = 'LOGIN_DO_LOGIN_SUCCESS';
export const LOGIN_DO_LOGIN_FAILURE = 'LOGIN_DO_LOGIN_FAILURE';
export const LOGIN_DO_LOGIN_DISMISS_ERROR = 'LOGIN_DO_LOGIN_DISMISS_ERROR';
export const LOGIN_RESET_PASSWORD_BEGIN = 'LOGIN_RESET_PASSWORD_BEGIN';
export const LOGIN_RESET_PASSWORD_SUCCESS = 'LOGIN_RESET_PASSWORD_SUCCESS';
export const LOGIN_RESET_PASSWORD_FAILURE = 'LOGIN_RESET_PASSWORD_FAILURE';
export const LOGIN_RESET_PASSWORD_DISMISS_ERROR = 'LOGIN_RESET_PASSWORD_DISMISS_ERROR';
export const LOGIN_CHANGE_PASSWORD_BEGIN = 'LOGIN_CHANGE_PASSWORD_BEGIN';
export const LOGIN_CHANGE_PASSWORD_SUCCESS = 'LOGIN_CHANGE_PASSWORD_SUCCESS';
export const LOGIN_CHANGE_PASSWORD_FAILURE = 'LOGIN_CHANGE_PASSWORD_FAILURE';
export const LOGIN_CHANGE_PASSWORD_DISMISS_ERROR = 'LOGIN_CHANGE_PASSWORD_DISMISS_ERROR';
export const LOGIN_SET_RESET_PASSWORD_LOADING = 'LOGIN_SET_RESET_PASSWORD_LOADING';
export const LOGIN_SET_CHANGE_PASSWORD_LOADING = 'LOGIN_SET_CHANGE_PASSWORD_LOADING';
export const LOGIN_CHECK_TOKEN_BEGIN = 'LOGIN_CHECK_TOKEN_BEGIN';
export const LOGIN_CHECK_TOKEN_SUCCESS = 'LOGIN_CHECK_TOKEN_SUCCESS';
export const LOGIN_CHECK_TOKEN_FAILURE = 'LOGIN_CHECK_TOKEN_FAILURE';
export const LOGIN_CHECK_TOKEN_DISMISS_ERROR = 'LOGIN_CHECK_TOKEN_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/login/redux/constants.js